import { render } from "./product-image-preview.vue?vue&type=template&id=37d31ec8&scoped=true"
import script from "./product-image-preview.vue?vue&type=script&lang=js"
export * from "./product-image-preview.vue?vue&type=script&lang=js"

import "./product-image-preview.vue?vue&type=style&index=0&id=37d31ec8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d31ec8"]])

export default __exports__